const updates = [
  { date: '2026-07-30', title: '探花最新地址已更新，新增备用入口3条', tag: '地址' },
  { date: '2026-07-29', title: '探花精选合集七月下旬版正式上线', tag: '合集' },
  { date: '2026-07-28', title: '探花在线本周热门排行出炉，经典回顾系列登顶', tag: '排行' },
  { date: '2026-07-27', title: '探花新地址维护完成，所有入口恢复正常访问', tag: '公告' },
  { date: '2026-07-26', title: '稀有探花资源专题页面上线，限时开放', tag: '专题' },
  { date: '2026-07-25', title: '探花官网移动端入口优化，加载速度提升40%', tag: '优化' },
  { date: '2026-07-24', title: '探花在线新增资源类型分类标签，浏览更便捷', tag: '功能' },
  { date: '2026-07-23', title: '精品探花用户推荐第三期结果公布', tag: '活动' },
  { date: '2026-07-22', title: '探花入口安全防护升级，增加多节点负载均衡', tag: '安全' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            最新动态
          </h2>
          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 before:content-[''] before:absolute before:left-3 before:top-2 before:bottom-2 before:w-px before:bg-background-300">
              {updates.map((item, idx) => (
                <div key={idx} className="relative pb-6 last:pb-0">
                  <div className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full border-2 border-background-50 bg-accent-500"></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                    <a
                      href="#updates"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item.title}
                    </a>
                    <span className="inline-block px-2 py-0.5 text-[10px] font-medium text-secondary-600 bg-secondary-100 rounded-full w-fit whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}